import DonationForm from "./DonationForm";

export default class DonationBlock {
    donationBlocks: NodeListOf<HTMLElement>;
    giftNumber: string;
    giftAmount: number;
    donationForm: typeof DonationForm;

    constructor() {
        this.donationBlocks = document.querySelectorAll('.xmas-donation-block');
        this.giftNumber = '0';
        this.giftAmount = 0;
        this.donationForm = DonationForm;
    }

    // Check if the donation block should be able to handle split payments
    isSplitPayment(donationBlock) {
        const input = donationBlock.querySelector('[name="is-split-payment"]');

        return input !== null
    }

    // Calulate the split payment value of the donation value
    calculateSplitPayment(donationValue) {
        const value = parseFloat(donationValue) * 100 / 3 / 100;
        const valueAsString = value.toString();
        const dp = valueAsString.indexOf('.');

        if (valueAsString.substr(dp).length > 3) {
            return valueAsString.substr(0, dp + 3);
        }

        return value.toFixed(2)
    }

    // Determine which month names to show in the split payment timeline
    getSplitDates() {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        const d = new Date();
        const monthId = d.getMonth();
        const dates = ['Today'];

        if (monthId < 11) {
            dates.push(months[monthId + 1])
        }

        if (monthId < 10) {
            dates.push(months[monthId + 2])
        }

        if (monthId >= 10) {
            dates.push(months[0])
        }

        if (monthId >= 11) {
            dates.push(months[1])
        }

        return dates;
    }

    init() {
        if (this.donationBlocks.length > 0) {
            Array.prototype.forEach.call(this.donationBlocks, donationBlock => {

                const customDonationLabel = donationBlock.querySelector('.custom-donation-label');
                const customDonation = donationBlock.querySelector('.custom-donation');
                const donationOptions = donationBlock.querySelectorAll('.donation-input');
                const donateButton = donationBlock.querySelector('.donate-button');
                const splitDonateButton = donationBlock.querySelector('.split-donate-button');
                const splitDonateValue = donationBlock.querySelectorAll('.split-donate-value');
                const splitDonateDate = donationBlock.querySelectorAll('.split-donate-date');
                const donationTypeSelection = donationBlock.querySelector('#DropDownSearch');
                const roundUpButton = donationBlock.querySelector('.roundup-checkbox input[name="roundup"]')
                const roundUpLabel = donationBlock.querySelector('.roundup-checkbox')
                const roundUpText = donationBlock.querySelector('.roundup-checkbox span.roundup-amount')
                const roundUpThanks = donationBlock.querySelector('.roundup-thanks');
                const maxErrorMessage = donationBlock.querySelector('#maxErrorMessage');
                const splitPaymentEnabled = donationBlock.querySelector('.donation-split-payment__enabled');
                const splitPaymentDisabled = donationBlock.querySelector('.donation-split-payment__disabled');
                const isSplitPayment = this.isSplitPayment(donationBlock);
                const maxAmount = 20000;

                if (isSplitPayment) {
                    const dates = this.getSplitDates();

                    splitDonateDate.forEach((el, i) => {
                        el.innerHTML = dates[i];
                    })
                }

                if (donationTypeSelection != null) {
                    donationTypeSelection.addEventListener('change', () => {
                        var donationType = donationTypeSelection.querySelector(':checked').getAttribute('data-modal-target')
                        var selectedOption = donationTypeSelection.querySelector(':checked');
                        var donationUrl = selectedOption.value;
                        donateButton.setAttribute("data-modal-target", donationType);
                        donateButton.setAttribute("data-url-target", donationUrl)
                        
                        if (isSplitPayment) {
                            splitDonateButton.setAttribute("data-modal-target", donationType);
                            splitDonateButton.setAttribute("data-url-target", donationUrl)
                        }
                    });
                }

                if (roundUpButton) {
                    roundUpButton.addEventListener('click', () => {

                        if (roundUpButton.checked) {
                            console.log('check')
                            roundUpThanks.classList.remove('hidden');
                            roundUpLabel.classList.add('hidden');

                            if (customDonation.value !== null && customDonation.value !== "" && customDonation.value !== "0" && customDonation.value <= maxAmount) {
                                let donationValue = Math.ceil(customDonation.value / 10) * 10;
                                donateButton.innerHTML = 'Donate &pound;' + donationValue;
                                donateButton.value = donationValue;

                                if (isSplitPayment) {
                                    const splitValue = this.calculateSplitPayment(donationValue);

                                    splitDonateButton.innerHTML = 'Donate &pound;' + splitValue + ' for 3 months';
                                    splitDonateButton.value = donationValue;
                                    splitDonateButton.setAttribute('data-split-value', splitValue);

                                    splitDonateValue.forEach(el => {
                                        el.innerHTML = '&pound;' + splitValue
                                    });
                                }
                            }
                            else {

                                Array.prototype.forEach.call(donationOptions, donationOption => {

                                    let donationValue = Math.ceil(donationOption.value / 10) * 10;

                                    if (donationOption.checked) {
                                        donateButton.innerHTML = 'Donate &pound;' + donationValue;
                                        donateButton.value = donationValue;
                                        this.giftNumber = donationOption.getAttribute('data-gift-number');
                                        this.giftAmount = donateButton.getAttribute('data-gift-amount');
                                        donateButton.setAttribute("data-gift-amount", this.giftNumber);

                                        if (isSplitPayment) {
                                            const splitValue = this.calculateSplitPayment(donationValue);

                                            splitDonateButton.innerHTML = 'Donate &pound;' + splitValue + ' for 3 months';
                                            splitDonateButton.value = donationValue;
                                            splitDonateButton.setAttribute('data-split-value', splitValue);

                                            splitDonateValue.forEach(el => {
                                                el.innerHTML = '&pound;' + splitValue
                                            });
                                        }
                                    }

                                })
                            }


                        }
                        else {

                            roundUpThanks.classList.add('hidden');
                            roundUpLabel.classList.remove('hidden');

                            if (customDonation.value !== null && customDonation.value !== "" && customDonation.value !== "0" && customDonation.value <= maxAmount) {
                                let donationValue = customDonation.value;
                                donateButton.innerHTML = 'Donate &pound;' + donationValue;
                                donateButton.value = donationValue;
                            }
                            else {

                                Array.prototype.forEach.call(donationOptions, donationOption => {

                                    let donationValue = donationOption.value;

                                    if (donationOption.checked) {
                                        donateButton.innerHTML = 'Donate &pound;' + donationValue;
                                        donateButton.value = donationValue;
                                        this.giftNumber = donationOption.getAttribute('data-gift-number');
                                        this.giftAmount = donateButton.getAttribute('data-gift-amount');
                                        donateButton.setAttribute("data-gift-amount", this.giftNumber)
                                    }

                                })
                            }

                        }



                    })
                }

                customDonation.addEventListener('click', () => {
                    customDonationLabel.classList.add('is-active');
                    Array.prototype.forEach.call(donationOptions, donationOption => {
                        donationOption.checked = false;
                    });

                    donateButton.disabled = true;

                    if (isSplitPayment) {
                        splitDonateButton.disabled = true;
                    }

                    if (customDonation.value !== null && customDonation.value !== "" && customDonation.value !== "0") {
                        donateButton.disabled = false;

                        if (isSplitPayment) {
                            splitDonateButton.disabled = false;
                        }
                    }
                });

                customDonation.addEventListener('input', () => {

                    if (roundUpButton) {
                        roundUpThanks.classList.add('hidden');
                        roundUpLabel.classList.remove('hidden');
                        roundUpButton.checked = false;
                    }

                    const minAmount = 1;
                    let donationValue = customDonation.value;

                    if (donationValue > maxAmount) {
                        maxErrorMessage.classList.remove('hidden');
                       
                        customDonation.value = maxAmount;
                        donationValue = maxAmount;
                        donateButton.value = maxAmount;
                        donateButton.innerHTML = 'Donate &pound;' + maxAmount + (isSplitPayment ? ' today' : '');

                        if (isSplitPayment) {
                            const splitValue = this.calculateSplitPayment(maxAmount);

                            splitDonateButton.value = maxAmount;
                            splitDonateButton.setAttribute('data-split-value', splitValue);
                            splitDonateButton.innerHTML = 'Donate &pound;' + splitValue + ' for 3 months';

                            splitDonateValue.forEach(el => {
                                el.innerHTML = '&pound;' + splitValue
                            });
                        }

                        if (roundUpButton) {
                            roundUpThanks.classList.add('hidden');
                            roundUpLabel.classList.add('hidden');
                            roundUpButton.checked = false;
                        }
                     
                    }

                    else {
                        maxErrorMessage.classList.add('hidden');
                    }


                    if (donationValue != "" && donationValue < minAmount) {
                        customDonation.value = minAmount;
                        donationValue = minAmount;
                        donateButton.value = minAmount;
                        donateButton.innerHTML = 'Donate &pound;' + minAmount;
                    }

                    if (donationValue === "00") { 
                        customDonation.value = minAmount;
                        donationValue = minAmount;
                        donateButton.value = minAmount;
                        donateButton.innerHTML = 'Donate &pound;' + minAmount;
                    }

                    if (typeof donationValue === 'string') {
                        if (donationValue.includes(".")) {
                            let pointPosition = donationValue.indexOf(".");

                            if (donationValue.length - pointPosition > 3) {
                                customDonation.value = donationValue.slice(0, -1);
                            }
                        }
                    }

                    if (customDonation.value % 10 === 0) {
                        console.log("Remainder zero so don't prompt");
                        // hide all roundup functionality

                        if (roundUpButton) {
                            roundUpThanks.classList.add('hidden');
                            roundUpLabel.classList.add('hidden');
                        }
                    }

                    if (roundUpButton && roundUpButton.checked) {
                        console.log('value', customDonation.value)
                        donationValue = Math.ceil(customDonation.value / 10) * 10;
                       

                        roundUpText.innerHTML = donationValue;
                       
                    }
                    else if (roundUpButton && donationValue <= maxAmount) {
                        var donationValueRoundUp = Math.ceil(customDonation.value / 10) * 10;
                        roundUpText.innerHTML = donationValueRoundUp;
                    }
                    else {
                        donationValue = customDonation.value;
                        console.log('no round up')
                       
                    }

                    if (donationValue !== null && donationValue !== "" && donationValue !== "0") {
                        donateButton.disabled = false;
                        donateButton.innerHTML = 'Donate &pound;' + donationValue + (isSplitPayment ? ' today' : '');
                        donateButton.value = donationValue;
                        this.giftNumber = customDonation.getAttribute('data-gift-number');
                        this.giftAmount = donateButton.getAttribute('data-gift-amount');
                        donateButton.setAttribute("data-gift-amount", this.giftNumber)

                        if (isSplitPayment) {
                            const splitValue = this.calculateSplitPayment(donationValue);

                            splitDonateButton.innerHTML = 'Donate &pound;' + splitValue + ' for 3 months';
                            splitDonateButton.value = donationValue;
                            splitDonateButton.setAttribute('data-split-value', splitValue);
                            splitDonateButton.setAttribute("data-gift-amount", this.giftNumber)

                            splitDonateValue.forEach(el => {
                                el.innerHTML = '&pound;' + splitValue
                            });

                            if (parseFloat(donationValue) <= 500) {
                                splitDonateButton.disabled = false;
                                splitPaymentEnabled.removeAttribute('hide');
                                splitPaymentDisabled.setAttribute('hide', 'true');
                            } else {
                                splitDonateButton.disabled = true;
                                splitPaymentEnabled.setAttribute('hide', 'true');
                                splitPaymentDisabled.removeAttribute('hide');
                            }
                        }
                    }
                    else {
                        donateButton.disabled = true;
                        donateButton.innerHTML = 'Donate';

                        if (isSplitPayment) {
                            splitDonateButton.disabled = true;
                            splitDonateButton.innerHTML = 'Donate';
                        }
                    }
                });

                Array.prototype.forEach.call(donationOptions, donationOption => {
                  
                    let donationValue = donationOption.value;
                   
                    if (donationOption.checked) {
                        donateButton.innerHTML = 'Donate &pound;' + donationValue + (isSplitPayment ? ' today' : '');
                        donateButton.value = donationValue;
                        this.giftNumber = donationOption.getAttribute('data-gift-number');
                        this.giftAmount = donateButton.getAttribute('data-gift-amount');
                        donateButton.setAttribute("data-gift-amount", this.giftNumber)

                        if (isSplitPayment) {
                            const splitValue = this.calculateSplitPayment(donationValue);

                            splitDonateButton.innerHTML = 'Donate &pound;' + splitValue + ' for 3 months';
                            splitDonateButton.value = donationValue;
                            splitDonateButton.setAttribute('data-split-value', splitValue);
                            splitDonateButton.setAttribute("data-gift-amount", this.giftNumber)

                            splitDonateValue.forEach(el => {
                                el.innerHTML = '&pound;' + splitValue
                            });

                            if (parseFloat(donationValue) <= 500) {
                                splitDonateButton.disabled = false;
                                splitPaymentEnabled.removeAttribute('hide');
                                splitPaymentDisabled.setAttribute('hide', 'true');
                            } else {
                                splitDonateButton.disabled = true;
                                splitPaymentEnabled.setAttribute('hide', 'true');
                                splitPaymentDisabled.removeAttribute('hide');
                            }
                        }
                    }
                   

                    donationOption.addEventListener('change', () => {
                        if (roundUpButton && roundUpThanks) {
                            roundUpThanks.classList.add('hidden');
                            roundUpLabel.classList.remove('hidden');
                            roundUpButton.checked = false;
                        }
                        maxErrorMessage.classList.add('hidden');
                        customDonationLabel.classList.remove('is-active');
                        customDonation.value = "";
                        donateButton.disabled = false;

                        if (isSplitPayment) {
                            if (parseFloat(donationValue) <= 500) {
                                splitDonateButton.disabled = false;
                                splitPaymentEnabled.removeAttribute('hide');
                                splitPaymentDisabled.setAttribute('hide', 'true');
                            } else {
                                splitDonateButton.disabled = true;
                                splitPaymentEnabled.setAttribute('hide', 'true');
                                splitPaymentDisabled.removeAttribute('hide');
                            }
                        }

                     
                        if (roundUpButton && roundUpButton.checked) {
                            donationValue = Math.ceil(donationValue / 10) * 10;
                            roundUpText.innerHTML = donationValue;
                            donateButton.value = donationValue;
                            donateButton.innerHTML = 'Donate &pound;' + donationValue;
                        }
                        else if (roundUpButton && customDonation.value <= maxAmount) {
                           var donationValueRoundUp = Math.ceil(donationValue / 10) * 10;
                            roundUpText.innerHTML = donationValueRoundUp;
                            donateButton.innerHTML = 'Donate &pound;' + donationValue;
                            donateButton.value = donationValue;
                        }
                        else {
                            donateButton.innerHTML = 'Donate &pound;' + donationValue + (isSplitPayment ? ' today' : '');
                            donateButton.value = donationValue;

                            //if (isSplitPayment) {
                            //    const splitValue = this.calculateSplitPayment(donationValue);

                            //    splitDonateButton.innerHTML = 'Donate &pound;' + splitValue + ' for 3 months';
                            //    splitDonateButton.value = donationValue;
                            //    splitDonateButton.setAttribute('data-split-value', splitValue);

                            //    splitDonateValue.forEach(el => {
                            //        el.innerHTML = '&pound;' + splitValue
                            //    });
                            //}
                        }

                        if (isSplitPayment) {
                            const splitValue = this.calculateSplitPayment(donationValue);

                            splitDonateButton.innerHTML = 'Donate &pound;' + splitValue + ' for 3 months';
                            splitDonateButton.value = donationValue;
                            splitDonateButton.setAttribute('data-split-value', splitValue);

                            splitDonateValue.forEach(el => {
                                el.innerHTML = '&pound;' + splitValue
                            });
                        }

                        this.giftNumber = donationOption.getAttribute('data-gift-number');
                        this.giftAmount = donateButton.getAttribute('data-gift-amount');

                       
                        donateButton.setAttribute("data-gift-amount", this.giftNumber)

                        if (isSplitPayment) {
                            splitDonateButton.setAttribute("data-gift-amount", this.giftNumber)
                        }
                    });

                    //document.addEventListener("change", someListener);

                    //function someListener(event) {
                    //    var element = event.target;
                    //    donationBlock.querySelectorAll('.donation-input');
                    //    if (element.classList.contains("donation-input")) {
                    //        let donationValue = element.value;
                    //        customDonationLabel.classList.remove('is-active');
                    //        customDonation.value = "";
                    //        donateButton.disabled = false;
                    //        donateButton.innerHTML = 'Donate &pound;' + donationValue;
                    //        donateButton.value = donationValue;
                    //        this.giftNumber = element.getAttribute('data-gift-number');
                    //        //this.giftAmount = donateButton.getAttribute('data-gift-amount');
                    //        donateButton.setAttribute("data-gift-amount", this.giftNumber)
                    //    }
                    //}

                });

            });

        }
    }
}